import React from 'react';
import './creditCustomer.css';
import profile from '../../images/splash/prof.png';
import { useState,useEffect } from 'react';
import axios from 'axios';
import { var_api,image_api } from '../constant';
import Swal from 'sweetalert2';
import { useHistory } from 'react-router-dom';
import { Label, Tooltip,Input, Row,Col } from 'reactstrap';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import swal from 'sweetalert';
import EmailTemplate from './emailTemp';
import { useRef } from 'react';
import Layout from '../NewHeader/Layout';
import DefaultProfileImage from '../../images/profile.png';
import Pagination from 'react-js-pagination';
import Table from 'react-bootstrap/Table';
import Loader from '../Loader/Loader';


const CreditCustomer = () => {
   const [ users,setUsers ] =  useState([]);
   const fileInputRef = useRef(null);
   const [ rytUser,setRytUser ] =  useState([]);
   const [ tables,setTables ] =  useState([]);
   const [ rejectremark,setRejectRemarks ] = useState('');
   const [dataID, setDataID] = useState('');

   const [ shopId,setShopId ] = useState();
   const [ searchQuery,setSearchQuery] = useState('');
   const [ searchTrans,setSearchTrans] = useState('');
   const history = useHistory();
   const [showRight, setShowRight] = useState(true);
   const [creditId,setCreditId] = useState(' ');
   const [ transaction,setTransaction ] = useState([]);
   const [ orderDetails,setOrderDetails ] = useState();
   const [totalAmount, setTotalAmount] = useState(0);
   const [balance1, setBalance] = useState(0);
   const [ laBal,setLaBal ] = useState();
   const [ totalPaid,setTotalPaid ] = useState();
   const [ record,setRecord ] = useState([]);
   const [show, setShow] = useState(false);
   const [showOrder, setShowOrder] = useState(false);
   const [showPayment, setShowPayment] = useState(false);
   const [maxiShow, setMaxiShow] = useState(false);
   const [searchMonth, setSearchMonth] = useState('');
   const [ paidStatus, setPaidStatus] = useState('');
   const [startDate, setStartDate] = useState('');
   const [formattedStartDate, setFormattedStartDate] = useState('');
   const [formattedEndDate, setFormattedEndDate] = useState('');
   const [ payableAmount, setPayableAmount] = useState();
   const [isOpen, setIsOpen] = useState(false);
   const [ isEdit,setIsEdit ] = useState(false);
   const [puttooltipOpen, setPutToolTipOpen] = useState([]);
   const [actiontooltipOpen, setActionToolTipOpen] = useState([]);
   const [isOpenPaymode, setIsOpenPaymode] = useState(false);
   const [selectedAmounts, setSelectedAmounts] = useState([]);
   const [paymodes, setPaymodes] = useState([]);
   const [formData, setFormData] = useState({
    customer_name:'',
    email_id:'',
    mobile_no:'',
    password:'',
    profile_image:"",  
    credit_limit:''  ,
    rejected_remarks:'',
    approval_status:'',
    shop_id:'',
    due_date:'',
    address:'',
    city:'',
    pincode:'',
    state:'',
    country:'',

  });
  const [updateFormData, setUpdateFormData] = useState({
    id:null,
    name:'',
    email:'',
    country_code:'',
    phone_no:'',
    user_gov_id:'',
    user_profile:"",  
    maxCredit:''  
  });
  const [createLoading, setCreateLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const [showrePop, showRemark] = useState(false);
  const [isOpenView, setIsOpenView] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
 

    useEffect(() => {
      fetchTables();
        // handleListPayModes();
      }, []);


   
    
      //get credit user data
      const fetchTables = async () => {
        const shop_id = localStorage.getItem('ShopId');
        const token = localStorage.getItem('Token');
    
        try {
          const response = await axios.get(
            `${var_api}credit-user-request/get-shop-customers/${shop_id}`,
            {
              headers: {
                Authorization: `${token}`, // Add the token to the Authorization header dynamically
              },
            }
          );
          console.log("Response received:", response);
          const user = response.data.data;
          setTables(user);
        } catch (error) {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error updating data:", error);
          }
        }
      };


       //get pending payment start date
       const fetchStartDate = async (Id) => {
        const shopid = localStorage.getItem('shopId');
       try {
        const response = await axios.get(`${var_api}/api/creditorder/get-start-date/${Id}/${shopid}` );
        const use = response.data
       setStartDate(use);
       console.log(use);
      }catch (error) {
        console.log('Error fetching data:', error);
       
        }
      };


      const toggleActionTooltip = (index) => {
        const actionTooltipOpen = [...actiontooltipOpen];
        actionTooltipOpen[index] = !actionTooltipOpen[index];
        setActionToolTipOpen(actionTooltipOpen);
      };

      const togglePutTooltip = (index) => {
        const putTooltipOpen = [...puttooltipOpen];
        putTooltipOpen[index] = !putTooltipOpen[index];
        setPutToolTipOpen(putTooltipOpen);
      };



 //calculate balance amount and total paid amount
        const fetchBal = async (id) => {
            
           try {
            const response = await axios.get(`${var_api}/api/payment/balancedata/${id}/${shopId}` );
            const data = response.data.balance;
            const totalpay = response.data.totalPaid;
            const finalAmount =  response.data.totalAmount
            setTotalPaid(totalpay)
            setLaBal(data);
            setTotalAmount(finalAmount);
            console.log("balance",laBal);
          }catch (error) {
            console.log('Error fetching data:', error);
            setUsers([]);
            }
          };


        //get all the data from payment record
          const fetchRecord = async (id) => {
            setShow(true)
            try {
             const response = await axios.get(`${var_api}/api/payment/fulldata/${id}/${shopId}` );
             const data = response.data.results;
 
             setRecord(data);
             console.log("balance",record, rytUser);
             
           }catch (error) {
             console.log('Error fetching data:', error);
             setUsers([]);
             }
           };


           //get order details for particular credit order
           const OrderDetails = async (id, status) => {
            setShowOrder(true)
            try {
             const response = await axios.get(`${var_api}/api/creditorder/orderitemshistory/${id}` );
             const data = response.data;
 
             setOrderDetails(data);
             setPaidStatus(status)
             console.log("order details",orderDetails);
             
           }catch (error) {
             console.log('Error fetching data:', error);
             setOrderDetails([]);
             }
           };


           //get order details for particular group Location order
           const GLOrderDetails = async (id, status) => {
            setShowOrder(true)
            try {
             const response = await axios.get(`${var_api}/api/creditorder/grouplocationorder/${id}` );
             const data = response.data.results[0];
 
             setOrderDetails(data);
             setPaidStatus(status)
             console.log("order details",orderDetails);
             
           }catch (error) {
             console.log('Error fetching data:', error);
             setOrderDetails([]);
             }
           };
    
  
  

    // get the credit order history data
        const fetchTransData = async (id,user) => {
            const shopId = localStorage.getItem('shopId');
           try {
            const response = await axios.get(`${var_api}/api/creditorder/orderhistory/${shopId}/${id}` );
            const data = response.data
            console.log(data)
            if(data.results.length > 0){
              setTransaction(data.results);
            }else{
              setTransaction([]);
            }

           
             // Calculate the total amount from 'data' and store it in 'totalAmount'
            //  const calculatedTotal = data.reduce((accumulator, item) => accumulator + item.quantity * item.unit_price, 0);
             

            //  if(user.maxCredit<totalAmount){
            //   console.log("max",user.maxCredit);
            //   console.log("total",totalAmount);
            //   Swal.fire(`${user.name} meet the maximum limit`);
            // }
             
          }catch (error) {
            console.log('Error fetching data:', error);
            setTransaction([]);
            
            }
          };

      
          const handleEditClose = () =>{
            setIsEdit(false);
          }

//close the paymode modal
          const handlePaymodeModalClose = () =>{
            setIsOpenPaymode(false);
          }

          //input onchange for update
  const handleUpdateInputChange = (e) => {
    const { name, value } = e.target;
    setUpdateFormData({ ...updateFormData, [name]: value });
  };

  
  //onchange function for file for update
  const handleImageChangeUpdate = (e) => {
    const file = e.target.files[0];
    setUpdateFormData({ ...updateFormData, user_profile: file || updateFormData.user_profile});
  };

  const handleUpdateSubmit = async (e) => {
    console.log("update data before put",updateFormData)
    e.preventDefault(); 
    setUpdateLoading(true);
    const capitalizedCustomerName = capitalize(updateFormData.name);
       

    const formDataToSend = new FormData();
    formDataToSend.append('name', capitalizedCustomerName);
    formDataToSend.append('country_code', updateFormData.country_code);
    formDataToSend.append('phone_no', updateFormData.phone_no);
    formDataToSend.append('user_gov_id', updateFormData.user_gov_id);
    formDataToSend.append('email', updateFormData.email);
    formDataToSend.append('maxCredit', parseInt(updateFormData.maxCredit));
    formDataToSend.append('user_profile', updateFormData.user_profile);
    
  
     try {
      const response = await fetch(`${var_api}/api/credituser/put/${updateFormData.id}/${shopId}`, {
        method: 'PUT',
      body: formDataToSend,
    });
      if(response.status == 200){
        setIsEdit(false);
        setUpdateLoading(false);
        Swal.fire({
          title: 'Success',
          text: 'Credit Customer Updated Successfully.',
          icon: 'success',
          confirmButtonColor: '#007500', // Set the custom color for the Confirm button
        });
        setUpdateFormData({
          name:'',
          email:'',
          country_code:'',
          phone_no:'',
          user_gov_id:'',
          user_profile:null,  
          maxCredit:''  
        });
         // Clear the value of the file input element
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
        const data = await response.json();
        console.log('Registration successful!',data);
     
      }else {
        console.error('Failed to update shop:', response.statusText);
        // Handle error, e.g., show an error message to the user
        Swal.fire({
          title: 'error',
          text: 'Credit Customer Already Exist',
          icon: 'error',
          confirmButtonColor: '#007500', // Set the custom color for the Confirm button
        });
      }
      
      // Handle success scenario as needed
    } catch (error) {
        console.error('Error:', error);
        // Handle error scenario as needed
      }
    }
       
   

//create the new credit customer
      const handleCredit = async()=>{
        setFormData({});
        setIsOpen(true);
      };


       const handleSearchTrans = (e) => {
        setSearchTrans(e.target.value)
        };

        // Function to format date to dd-mm-yyyy format
const formatSEDate = (dateString) => {
  console.log(dateString);
  const dateObject = new Date(dateString);
  const day = dateObject.getDate();
  const month = dateObject.getMonth() + 1;
  const year = dateObject.getFullYear();

  // Pad single digit day/month with leading zero
  const formattedDay = day < 10 ? `0${day}` : day;
  const formattedMonth = month < 10 ? `0${month}` : month;

  return `${formattedDay}-${formattedMonth}-${year}`;
};


       //list the pay modes
  



     

      
//search the credit customer
    
      //search the transaction data
   
      
      //close the modal
      const handleCloseCreate = () => {
        setIsOpen(false);
      }


      //input onchange
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


  //onchange function for file
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFormData({ ...formData, profile_image: file });
  };

    // Function to capitalize the first letter of a string
const capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
 };

 const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = ("0" + date.getDate()).slice(-2);  // Add leading zero to day
  const month = ("0" + (date.getMonth() + 1)).slice(-2);  // Add leading zero to month
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;  // Return in DD-MM-YYYY format
};

  //post method for creating the shop
  const handleSubmit = async (e) => {
    console.log("update data before post",formData);
    const shop_id = localStorage.getItem('ShopId');
    e.preventDefault();  
    setCreateLoading(true);
    
    const created_by = localStorage.getItem('userId') || "";
    
        const capitalizedCountryName = capitalize(formData.customer_name);
       

    const formDataToSend = new FormData();
    formDataToSend.append('customer_name', formData.customer_name);
    formDataToSend.append('email_id', formData.email_id);
    formDataToSend.append('mobile_no', formData.mobile_no);
    formDataToSend.append('password', formData.password);
    formDataToSend.append('profile_image', formData.profile_image);
    formDataToSend.append('shop_id', shop_id); 
    formDataToSend.append('credit_limit', parseInt(formData.credit_limit));
    formDataToSend.append('rejected_remarks', '-');
    formDataToSend.append('approval_status', 1);
    formDataToSend.append('due_date',formatDate(formData.due_date));
    formDataToSend.append('address', (formData.address));
    formDataToSend.append('city', formData.city);
    formDataToSend.append('state', formData.state);
    formDataToSend.append('country',(formData.country));
    formDataToSend.append('pincode', formData.pincode);

     try {
      const token=localStorage.getItem('Token');
      const response = await fetch(`${var_api}customer-credit-request/create`, {
        method: 'POST',
      body: formDataToSend,
      headers:{
        Authorization:`${token}`
      }
    });
      if(response.status == 200){
        setIsOpen(false);
        Swal.fire({
          title: 'Success',
          text: 'Credit Customer Created Successfully.',
          icon: 'success',
          confirmButtonColor: '#007500', // Set the custom color for the Confirm button
        });
        setFormData({});
         // Clear the value of the file input element
        fetchTables();
    setCreateLoading(false);
        const data = await response.json();
        console.log('Registration successful!',data);
        
      }else {
        console.error('Failed to create shop:', response);
        if(response.status === 400){
          Swal.fire({
            icon:"error",
            text:`This Email Id Already Exist in your Credit Customer List`,
            confirmButtonColor:"#007500"
          })
        }else{
          Swal.fire({
            icon:"error",
            text:`Failed to Create cusotmer`,
            confirmButtonColor:"#007500"
          })
        }
        
      }
      
      // Handle success scenario as needed
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('Token'); // Clear the invalid token
        history.push('/')// Redirect to the Sign-In page
      } else {
        console.error("Error updating data:", error);
      }
      } finally {
        setCreateLoading(false);
      }
    };

    const getStatusDetails = (status) => {
      switch (status) {
        case 1:
          return { text: "Approved", color: "green" };
        case 2:
          return { text: "Rejected", color: "red" };
        default:
          return { text: "New", color: "blue" };
      }
    };
  
    const handleVerify = (id, rejected_remarks) => {
      const token = localStorage.getItem("Token"); // Replace with your token retrieval logic
      console.log("rejected_remarks", rejected_remarks)
      axios
        .put(
          `${var_api}credit-user-request/approval-put/${id}`,
          { approval_status: 1, reject_remarks: rejected_remarks || "-" }, // Request payload
          {
            headers: {
              Authorization: `${token}`, // Pass token in Authorization header
            },
          }
        )
        .then((response) => {
          Swal.fire({
            icon: 'success',
            text: 'Approved successfully',
            confirmButtonColor: '#007500',
          });
           // Update the specific request in selectedCustomer state
      setSelectedCustomer((prevState) => {
        const updatedRequests = prevState.credit_user_requests.map((request) => {
          if (request.id === id) {
            return { ...request, approval_status: 1, rejected_remarks: rejected_remarks || "-" };
          }
          return request;
        });
        return { ...prevState, credit_user_requests: updatedRequests };
      });

      // Optionally refresh the table or list
      fetchTables();
    })
          // Optionally refresh the list or update state
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error updating data:", error);
          }
        });
    };

        
    const openRemark = (dataId) => {
      showRemark(true);
      setRejectRemarks('');
      setDataID(dataId);
    };
    const handleReject = () => {
      const token = localStorage.getItem("Token"); // Replace with your token retrieval logic
    
      if (!rejectremark) {
        alert("Remarks are required for rejection");
        return;
      }
    
      axios
        .put(
          `${var_api}credit-user-request/approval-put/${dataID}`,
          { approval_status: 2, rejected_remarks: rejectremark }, // Request payload
          {
            headers: {
              Authorization: ` ${token}`, // Pass token in Authorization header
            },
          }
        )
        .then((response) => {
          Swal.fire({
            icon: 'success',
            text: 'Rejected successfully',
            confirmButtonColor: '#007500',
          });
          showRemark(false);
          setRejectRemarks("");
          // Update the specific request in selectedCustomer state
      setSelectedCustomer((prevState) => {
        const updatedRequests = prevState.credit_user_requests.map((request) => {
          if (request.id === dataID) {
            return { ...request, approval_status: 2, rejected_remarks: rejectremark || "-" };
          }
          return request;
        });
        return { ...prevState, credit_user_requests: updatedRequests };
      });

          // Optionally refresh the list or update state
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            localStorage.removeItem('Token'); // Clear the invalid token
            history.push('/')// Redirect to the Sign-In page
          } else {
            console.error("Error updating data:", error);
          }
        });
    };

    
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10); // Number of items per page
    const [searchTerm, setSearchTerm] = useState('');
  
    // Filtering tables based on search term
    const filteredTables = tables.filter((item) => {
      return (
        item.customer_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        String(item.mobile_no).toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.email_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
        String(item.address).toLowerCase().includes(searchTerm.toLowerCase()) ||
        String(item.city).toLowerCase().includes(searchTerm.toLowerCase()) ||
        String(item.pincode).toLowerCase().includes(searchTerm.toLowerCase()) ||
        String(item.country).toLowerCase().includes(searchTerm.toLowerCase()) ||
        String(item.credit_limit).toLowerCase().includes(searchTerm.toLowerCase()) ||
        String(item.due_date).toLowerCase().includes(searchTerm.toLowerCase()) 
      );
    });
  
    // Pagination logic
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredTables.slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = filteredTables.length;
  
    const handleSearchInput = (event) => {
      setSearchTerm(event.target.value);
      setCurrentPage(1); // Reset to the first page when search changes
    };
  
    const handlePageChange = (pageNumber) => {
      setCurrentPage(pageNumber);
    };


    //opens modal for view
    const openModalEye = (data) => {
      setIsOpenView(true);
      setSelectedCustomer(data);
      console.log(data);
    }


    return(
      <>         <Layout>
        {(createLoading || updateLoading)&& <Loader />}

      <div class="splitno">


        <div style={{ border: "none", padding: "15px", width: "100%", height: "auto", margin: "auto", borderRadius: "15px", backgroundColor: "white", boxShadow: " rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px, rgba(17, 17, 26, 0.1) 0px 24px 80px" }}>
          <Row>
            <div className="d-flex justify-content-between">
            
            <div><h4 className='ushe'>CREDIT CUSTOMER</h4></div>
            <div className="d-flex justify-content-between">
              <div>
            <Button variant='dark' onClick={handleCredit}  style={{fontSize:"14px",borderRadius:"10px", marginLeft:"10px"}}>Create Credit Customer</Button>{' '}
            </div>
            <div className='ms-4'>
            <input
              className="form-control m-0"
              type="text"
              placeholder="Search"
              style={{ width: "100%",float:"right" }}
              onChange={handleSearchInput}
            />
          </div>
            </div>
          
            
            </div>
          </Row>
      

          <div className="table-container" style={{ height: 'auto', overflowY: 'auto', marginTop: '10px' }}>
            <table className="table caption-top" style={{ borderColor: 'grey', width: '100%', margin: 'auto' }}>
              <thead>
                <tr style={{ fontWeight: 'bold' }}>
                  <th style={{ textAlign: 'left' }}>S.No</th>
                  {/* <th style={{ textAlign: 'left' }}>Shop Name</th> */}
                  <th style={{ textAlign: 'left' }}>Profile </th>

                  <th style={{ textAlign: 'left' }}>Customer Name</th>

                  <th style={{ textAlign: 'left' }}>Mobile</th>
                  <th style={{ textAlign: 'left' }}>Email ID</th>
                  <th style={{ textAlign: 'left' }}>Address</th>
                  <th style={{ textAlign: 'left' }}>City</th>
                  <th style={{ textAlign: 'left' }}>Pincode</th>
                  <th style={{ textAlign: 'left' }}>Country</th>

                  {/*  <th style={{ textAlign: 'left' }}>Credit Limit</th>
                  <th style={{ textAlign: 'left' }}>Due Date</th>
                  <th style={{ textAlign: 'left' }}>Status</th>
                  <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Remarks</th>*/}

                  <th style={{ textAlign: 'left' }}>View</th>

    
                </tr>
              </thead>
              <tbody className="body-half-screen">
  {currentItems && currentItems.length > 0 ? (
    currentItems.map((data, index) => (
      <tr key={index}>
        <td>{index+1}</td>
        <td style={{textTransform:"capitalize",textAlign:"left"}}> <img
               src={data.profile_image ? `${image_api}/${data.profile_image}` : DefaultProfileImage}
            alt="profile"
            style={{ width: '75px', height: '65px', objectFit: 'cover' }}
          /></td>
        <td>{data.customer_name || '-'}</td>
        <td>{data.mobile_no || '-'}</td>
        <td>{data.email_id || '-'}</td>
        <td>{data.address || '-'}</td>
        <td>{data.city || '-'}</td>

        <td>{data.pincode || '-'}</td>
        <td>{data.country || '-'}</td>

        {/* <td>{data.available_status===1 ? "Yes" : "No"}</td> */}
        {/*  <td>${data.credit_limit || '-'}</td>
        <td>{data.due_date || '-'}</td>

        
        <td>
  {(() => {
    const { text, color } = getStatusDetails(data.approval_status);
    return <h6 style={{ color }}>{text}</h6>;
  })()}
</td>

        <td>{data.rejected_remarks || '-'}</td>*/}
         <td >
        <Button variant="primary" size='sm' 
        onClick={()=>openModalEye(data)}
        ><i class="bi bi-eye"></i></Button>
        </td> 
        {/* <td>
  <div style={{ display: 'flex', gap: '5px' }}>
    {data.approval_status === 0 && (
      <>
        <Button variant="success" size="sm" onClick={() => handleVerify(data.id)}>
          VERIFY
        </Button>
        <Button variant="danger" size="sm" onClick={() => openRemark(data.id)}>
          REJECT
        </Button>
      </>
    )}
    {data.approval_status === 1 && (
      <Button variant="danger" size="sm" onClick={() => openRemark(data.id)}>
        REJECT
      </Button>
    )}
    {data.approval_status === 2 && (
      <Button variant="success" size="sm" onClick={() => handleVerify(data.id)}>
        VERIFY
      </Button>
    )}
  </div>
</td> */}

      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="14" style={{ textAlign: "center", color: "red", fontWeight: "bold", borderColor: "black" }}>
        No Credit Customer Available
      </td>
    </tr>
  )}
</tbody>
            </table>
            <Pagination
              activePage={currentPage}
              itemsCountPerPage={itemsPerPage}
              totalItemsCount={totalItems}
              pageRangeDisplayed={5}
              onChange={handlePageChange}
              itemClass="page-item"
              linkClass="page-link"
              innerClass="pagination justify-content-end mt-4"
              activeClass="active-pagination"
            />
            <div>
        
            </div>
          </div>
        </div>
      </div>



      <Modal
        show={showrePop}
        onHide={()=>showRemark(false)}
        backdrop="static"
        keyboard={false}
        size="m"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title> Remarks</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <lable className="form-lable">Remarks</lable>
            <input type="text" class="form-control" placeholder="Enter Remarks" id="input1"   name="e_name"  value={rejectremark}
      onChange={(e) => setRejectRemarks(e.target.value)}
      required/>
            <button className="btn btn-danger" style={{float:"right",margin:"5px",borderRadius:"15px"}} onClick={handleReject}>REJECT</button>

            </Modal.Body>
            </Modal>
      <Modal
        show={isOpen}
        onHide={handleCloseCreate}
        backdrop="static"
        keyboard={false}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title> Add Credit Customer </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <form  className="py-2" onSubmit={handleSubmit}>
          <div class="row">
            <div class="col">
               <label for="input1" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Customer Name</label>
              <input type="text" class="form-control" placeholder="Enter customer name" id="input1"  name="customer_name"  value={formData.customer_name}  onChange={handleInputChange} style={{borderRadius:"12px"}} required/>
            </div>
            <div class="col">
              <label for="input2" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Email</label>
              <input type="email" class="form-control" placeholder="Enter email" id="input2" name="email_id" value={formData.email_id} onChange={handleInputChange} style={{borderRadius:"12px"}} required/>
            </div>
            
          </div>
          <br/>
          <div class="row">
          <div class="col">
            <label for="input6" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}> Credit Limit</label>
              <input type="number" class="form-control" placeholder="Enter Credit Limit" id="input6" name="credit_limit" value={formData.credit_limit} onChange={handleInputChange} style={{borderRadius:"12px"}} required min="0.1" step="0.1"/>
            </div>
            <div class="col">
              <label for="input4" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Phone No</label>
              <input type="number" class="form-control" placeholder="Enter phone no" id="input4" name="mobile_no" value={formData.mobile_no} onChange={handleInputChange} style={{borderRadius:"12px"}} required/>
            </div>
          </div>
          <br/>
          <div class="row">
          <div class="col">
              <label for="input4" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Due Date</label>
              <input type="date" class="form-control" placeholder="Enter Due Date" id="input4" name="due_date" value={formData.due_date} onChange={handleInputChange} style={{borderRadius:"12px"}} required/>
            </div>
            <div class="col">
               <label for="input5" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Password</label>
              <input type="text" class="form-control" placeholder="Enter Password" id="input5" name="password" value={formData.password} onChange={handleInputChange} style={{borderRadius:"12px"}} required/>
            </div>
          
          </div>
          <br/>
          <div class="row">
            <div class="col">
            <label for="formFile" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Customer Profile</label>
              <input ref={fileInputRef} class="form-control" type="file" id="formFile" onChange={handleImageChange} style={{borderRadius:"12px"}} value={formData.shop_image}/>
            </div>
            <div class="col">
               <label for="input5" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Address</label>
              <input type="text" class="form-control" placeholder="Enter Address" id="input5" name="address" value={formData.address} onChange={handleInputChange} style={{borderRadius:"12px"}} required/>
            </div>
           
          </div>
          <br/>
          <div class="row">
          <div class="col">
              <label for="input4" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>City</label>
              <input type="text" class="form-control" placeholder="Enter City" id="input4" name="city" value={formData.city} onChange={handleInputChange} style={{borderRadius:"12px"}} required/>
            </div>
            <div class="col">
               <label for="input5" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>State</label>
              <input type="text" class="form-control" placeholder="Enter State" id="input5" name="state" value={formData.state} onChange={handleInputChange} style={{borderRadius:"12px"}} required/>
            </div>
          
          </div>
          <br/>
          <div class="row">
          <div class="col">
              <label for="input4" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>PinCode</label>
              <input type="text" class="form-control" placeholder=" Enter PinCode" id="input4" name="pincode" value={formData.pincode} onChange={handleInputChange} style={{borderRadius:"12px"}} required/>
            </div>
            <div class="col">
               <label for="input5" style={{color:"green",fontFamily:"serif",fontWeight:"bolder"}}>Country</label>
              <input type="text" class="form-control" placeholder="Enter Country" id="input5" name="country" value={formData.country} onChange={handleInputChange} style={{borderRadius:"12px"}} required/>
            </div>
          
          </div>
          <br/>
     <button className="btn btn-success" type="submit" style={{float:"right",margin:"5px",borderRadius:"15px"}}>Submit</button>
             
          </form>
          <button className="btn btn-danger" onClick={handleCloseCreate} style={{borderRadius:"15px",float:"right",marginTop:"-1px"}}>Close</button>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>


      <Modal
  show={isOpenView}
  onHide={() => setIsOpenView(false)}
  backdrop="static"
  keyboard={false}
  size="xl"
>
  <Modal.Header closeButton>
    {/* <Modal.Title>Delivery Dates (Order No - {orderNo})</Modal.Title> */}
    <Modal.Title>Delivery Dates</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    {
      selectedCustomer && (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin:"15px 70px"}}>
        <h6>
        Customer Name: <span style={{fontSize:"18px", color: "blue"}}>{selectedCustomer.customer_name}</span>
        </h6>
        <h6 >
        Mobile: <span style={{fontSize:"18px", color: "blue"}}>{selectedCustomer.mobile_no}</span>
        </h6>
        <h6>
          City: <span style={{fontSize:"18px", color: "blue"}}>{selectedCustomer.city || "-"}</span>
        </h6>
      </div>
      )
    }

    {/* Bill-Like List Design */}
    <Table hover style={{ marginBottom: "20px" }}>
      <thead>
        <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold", color: "green" }}>
        <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">S.No</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">credit Limit</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Due Date</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Approval Status</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Rejected remark</th>
          <th style={{textTransform:"capitalize",textAlign:"left"}} scope="col">Action</th>


        </tr>
      </thead>
      <tbody >
      {selectedCustomer && selectedCustomer.credit_user_requests.length > 0 ? (
    selectedCustomer.credit_user_requests.map((data, index) => (
          <tr key={index} style={{borderBottom:"0.5px solid black"}}>
       
            <td>{index+1}</td>
            <td>{data.credit_limit}</td>
            <td>{data.due_date}</td>
            <td>
  {(() => {
    const { text, color } = getStatusDetails(data.approval_status);
    return <h6 style={{ color }}>{text}</h6>;
  })()}
</td>
            <td>{data.rejected_remarks}</td>
            <td>
  <div style={{ display: 'flex', gap: '5px' }}>
    {data.approval_status === 0 && (
      <>
        <Button variant="success" size="sm" onClick={() => handleVerify(data.id,data.rejected_remarks)}>
          APPROVE
        </Button>
        <Button variant="danger" size="sm" onClick={() => openRemark(data.id)}>
          REJECT
        </Button>
      </>
    )}
    {data.approval_status === 1 && (
      <Button variant="danger" size="sm" onClick={() => openRemark(data.id)}>
        REJECT
      </Button>
    )}
    {data.approval_status === 2 && (
      <Button variant="success" size="sm" onClick={() => handleVerify(data.id, data.rejected_remarks)}>
        APPROVE
      </Button>
    )}
  </div>
</td>
            </tr>
    ))
           
      ) : (
        <tr>
          <td colSpan="6" style={{ textAlign: "center", color: "red", fontWeight: "bold" }}>
            No data available
          </td>
        </tr>
      )}
</tbody>

    </Table>
    {/* <button
      className="btn btn-danger"
      onClick={() => setItempopup(false)}
      style={{ borderRadius: "15px", float: "right", marginTop: "-1px" }}
    >
      Cancel
    </button> */}
  </Modal.Body>
</Modal>


      {/* </div> */}
    </Layout></>
        
    )
}

export default CreditCustomer;